import { RiDeleteBin5Fill } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";
import { FaList } from "react-icons/fa";
import AppRoutePath from "../../../router/AppRoutePath";
import { AuthorizationList, CanAccess } from "../../../components/template/authorization/Authorization";

export const renderColumns = (handleEdit, handleDelete, code_product) => {
  if (code_product == 1) {
    return [
      {
        dataIndex: "brand",
        key: "brand",
        title: "Merk",
      },
      {
        dataIndex: "model",
        key: "model",
        title: "Tipe",
      },
      {
        dataIndex: "minPrice",
        key: "minPrice",
        title: "Harga Minimal",
      },
      {
        dataIndex: "maxPrice",
        key: "maxPrice",
        title: "Harga Maksimal",
      },
      {
        dataIndex: "action",
        key: "action",
        title: "Aksi",
        width: "12%",
        render: (_, record) => (
          <div style={{ textAlign: "center", display: "flex" }}>
            <CanAccess
              role={AuthorizationList.update_product}
              yes={
                <div className="mr-2" onClick={() => handleEdit(record)}>
                  <BiEditAlt
                    style={{
                      fontSize: 24,
                      color: "#F5CB58",
                      cursor: "pointer",
                    }}
                  />
                </div>
              }
            />
            <CanAccess
              role={AuthorizationList.delete_product}
              yes={
                <div className="mr-2" onClick={() => handleDelete(record)}>
                  <RiDeleteBin5Fill
                    style={{
                      fontSize: 24,
                      color: "#F23434",
                      cursor: "pointer",
                    }}
                  />
                </div>
              }
            />
          </div>
        ),
      },
    ];
  } else if (code_product == 2 || code_product == 3) {
    return [
      {
        dataIndex: "brand",
        key: "brand",
        title: "Merk",
      },
      {
        dataIndex: code_product == 3 ? "type" : "model",
        key: code_product == 3 ? "type" : "model",
        title: code_product == 3 ? "Tipe" : "Model",
      },
      {
        dataIndex: code_product == 3 ? "model" : "type",
        key: code_product == 3 ? "model" : "type",
        title: code_product == 3 ? "Model" : "Tipe",
      },
      {
        dataIndex: "year",
        key: "year",
        title: "Tahun",
      },
      {
        dataIndex: "minPrice",
        key: "minPrice",
        title: "Harga Minimal",
      },
      {
        dataIndex: "maxPrice",
        key: "maxPrice",
        title: "Harga Maksimal",
      },
      {
        dataIndex: "action",
        key: "action",
        title: "Aksi",
        width: "12%",
        render: (_, record) => (
          <div style={{ textAlign: "center", display: "flex" }}>
            <CanAccess
              role={AuthorizationList.update_product}
              yes={
                <div className="mr-2" onClick={() => handleEdit(record)}>
                  <BiEditAlt
                    style={{
                      fontSize: 24,
                      color: "#F5CB58",
                      cursor: "pointer",
                    }}
                  />
                </div>
              }
            />
            <CanAccess
              role={AuthorizationList.delete_product}
              yes={
                <div className="mr-2" onClick={() => handleDelete(record)}>
                  <RiDeleteBin5Fill
                    style={{
                      fontSize: 24,
                      color: "#F23434",
                      cursor: "pointer",
                    }}
                  />
                </div>
              }
            />
          </div>
        ),
      },
    ];
  }
};

export const dataBreadcrumb = [
  { label: "Kategori Produk", route: AppRoutePath.PRODUCT_CATEGORY },
  { label: "Daftar Produk", route: null },
];

export const productsListFilter = {
  search: "",
  page: 1,
  pageSize: 10,
};
